import { ConsentWorkflow, StartConsentForm, StartConsentFormResponse } from '@/api/dtos';
import { OnlinePatientManagementContext } from '@ngt/opms';
import { useCallback, useContext } from 'react';

export interface UseStartConsentFormOptions {
    revalidateForm?: () => Promise<unknown>;
    refreshPatient?: () => Promise<unknown>;
    refreshSummary?: () => Promise<unknown>;
}

const useStartConsentForm = ({
    revalidateForm,
    refreshPatient,
    refreshSummary
}: UseStartConsentFormOptions = {}) => {
    const { serviceStackClient } = useContext(OnlinePatientManagementContext);

    return useCallback(async (request: StartConsentForm) => {
        const response = await serviceStackClient.post<StartConsentFormResponse>(request);

        await Promise.all([
            revalidateForm?.(),
            request.workflow === ConsentWorkflow.EConsent ? refreshPatient?.() : undefined,
            refreshSummary?.()
        ]);

        return response;
    }, [serviceStackClient, revalidateForm, refreshPatient, refreshSummary]);
};

export default useStartConsentForm;
